import { render } from "./Reply.vue?vue&type=template&id=20e81862"
import script from "./Reply.vue?vue&type=script&lang=js"
export * from "./Reply.vue?vue&type=script&lang=js"

import exportComponent from "C:\\takahashi\\Julie\\pb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__